import {LoggerController} from "./../../core/logger";

class FieldController extends LoggerController{
    static get $inject(){ return   ['$log', '$scope', '$element'] }
    constructor($log, $scope, $element){
        super($log);
        this.haveError = false;
        this.$scope = $scope;
        this.$element = $element;
        this.errorMessage =false;

        this.$scope.$on('errorEvent', this.onErrorEvent.bind(this));

       
        this.loadTootips();

        this.controlClass = this.constructor.name.replace('Controller','')

        this.fields = [];

        if(this.onInitFields){
            this.$scope.$on('onInitFields', this.onInitFields.bind(this));
        }

        if(this.onSaveForm){
            this.$scope.$on('before::save', this.onSaveForm.bind(this));
        }
       
        this.$scope.$on('reset::error', this.onResetError.bind(this));
        this._fields ={}; 
    }

    onResetError(){
        this.haveError = false;
        this.errorMessage =false;
    }

    loadTootips (){
      
    }
    
    $onInit(){
        //this.defaultFieldName = this.$element.attr('model').replace('$ctrl.bid.', '');
        let name = this.$element.attr('model').replace('$ctrl.bid.', '').replace('$ctrl.applicant.','').replace('$ctrl.','');
        
      //  console.log(this.label+' -  '+this.controlClass+'  create field-name : '+name+' <-> '+this.fieldName); 
        
        //console.info('field:: '+this.label+' -  '+this.controlClass+' - '+this.$element.attr('model').replace('$ctrl.bid.', '').replace('$ctrl.',''));
        
        
        if(!this.fieldName){
            this.fieldName =  name;
        }

        //console.info('InitFields '+this.controlClass+'  '+this.fieldName);
        this.$scope.$emit('onInitFields', {
            
            name:  this.fieldName ,
            type:  this.controlClass,
            field: this
        });

        if(!this.errorMessage){
            this.errorMessage =false;
        }
  
        
    }

    initScroll(tableHolder){
       
        tableHolder.each(function () {
            let self = $(this)
            if (self.find("table").outerWidth() > self.outerWidth()) {
              if (self.scrollLeft() < 2) {
                self.addClass("show-icon");
              }
            }
        });
        tableHolder.on("scroll", function () {
            let self = $(this)
            if (self.scrollLeft() < 2) {
                self.addClass("show-icon");
            } else {
                self.removeClass("show-icon");
            }
        });
    }
   


    onErrorEvent(event, data){
     
        if(!data.field || data.field!==this.fieldName){
            if(data.haveField!==true){
                data.haveField = false;
            }
            return;
        }
        
        data.haveField = true;

        /*this.info('hsndle errorEvent::'+this.fieldName,{
            fieldName:this.fieldName,
            event:event, 
            data:data
        });*/

        this.haveError = true;
        this.errorMessage = data.message;

      //  this.toolTipError.tooltipster('content', this.errorMessage );
       
    }

    $postLink(){
 
 
        this.checkErrorsAuto()

        let tableHolder = $(".table-holder", this.$element)
        if(tableHolder.length){
            this.initScroll();
        }

    }

    checkErrorsAuto(){
        return ;
/*
        if(!this.fieldName){
            return ;
        }
        var whatFind= this.fieldName;
        let error = errorsMaster.find(obj => {
            if(!obj['OBMENFIELDS']){
                return false;
            }

            return obj['OBMENFIELDS'] === whatFind 
        });

        if(!error && false){

            bx.ajax.runComponentAction('cript:desktop', 'master-errors-add', {
                mode:'class',
                data:{
                    code:this.fieldName, 
                    name:this.label,
                }
            })
        }
        */
    }
    redraw(){
        setTimeout(()=>this.$scope.$apply(), 1);
    }
}


export {FieldController}


// WEBPACK FOOTER //
// ./src/components/elements/elements.field.controller.js